import {useCallback} from 'react';
import {toast} from 'react-toastify';

import {
  extractErrorMessageFromApolloError,
  getErrMsgFromError,
} from '../util/errors';

const useJoinTeam = (createInviteMutation: any, refetch: any) => {
  const handleJoinTeamAs = useCallback(
    async (entityName, email, role) => {
      try {
        const result = await createInviteMutation({
          variables: {
            entityName,
            admin: false,
            email,
            role: role.value,
          },
        });

        if (result.errors != null) {
          toast(
            result.errors.map((e: {message: string}) => e.message).join(', ')
          );
          console.error(extractErrorMessageFromApolloError(result.errors));
          return;
        }
        await refetch?.();
      } catch (err) {
        const errMsg = getErrMsgFromError(err);
        toast(errMsg);
        if (errMsg != null) {
          console.error(errMsg);
        }
        return;
      }
    },
    [createInviteMutation, refetch]
  );
  return {handleJoinTeamAs};
};

export default useJoinTeam;
